import { z } from 'zod';

export const InputSchema = z.object({
    Countries: z.array(z.string()),
    Text: z.string(),
    Container: z.string().optional(),
});

export const SuccessResponseSchema = z.object({
    Items: z.array(
        z.object({
            Id: z.string(),
            Type: z.string(),
            Text: z.string(),
            Highlight: z.string(),
            Description: z.string(),
        })
    ),
});

export type SuccessResponseType = z.infer<typeof SuccessResponseSchema>;
export type AddressItemType = SuccessResponseType['Items'][number];

export const ErrorResponseSchema = z.object({
    Items: z.array(
        z.object({
            Error: z.string(),
            Description: z.string(),
            Cause: z.string(),
            Resolution: z.string(),
        })
    ),
});

type ErrorResponseType = z.infer<typeof ErrorResponseSchema>;

export type ResponseType =
    | { responseStatus: 'success'; data: SuccessResponseType }
    | { responseStatus: 'error'; data: ErrorResponseType };
